import React from "react";
import _chunk from "lodash/chunk";
import Heading from "@components/Heading";
import TopFaqCard from "@containers/Support/TopFaqCard";

const TopFaqs = ({ items }) => {
  if (!items || !items.length) {
    return null;
  }

  const chunkedItems = _chunk(items, Math.ceil(items.length / 2));

  return (
    <>
      <Heading
        title="Cele mai votate intrebari frecvente"
        as="h2"
        display="h1"
        classesProp="mb-3 lg:mb-2 -tracking-0.5 lg:-tracking-0.67 leading-30 lg:leading-normal"
      />

      <div className="overflow-hidden -ml-3 flex flex-wrap">
        {chunkedItems.map((chunk, i) => (
          <div key={i} className="w-full md:w-1/2 pl-3">
            {chunk.map((item) => (
              <div className="flex" key={item.title}>
                <TopFaqCard item={item} hasDropdown />
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default TopFaqs;
